export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13533.0bf7c736.jpg";